export type ActionProps<T extends (...args: any[]) => any> = Parameters<T>[0];
